import * as uuidgen from 'uuid';

export const LAST_VISITED_NOTIFICATIONS_STORAGE_KEY = 'last-visited-notifications';

export class MetaState {
    constructor(
        readonly errors: VegkartError[] = [],
        readonly lastHash: string = '',
        readonly notifications: Notification[] = validateNotifications(defaultNotifications),
        readonly lastVisitedNotifications: Date = getLastVisitedNotifications()
    ) {}

    override(modifyObject: { [P in keyof MetaState]?: MetaState[P] }): MetaState {
        return Object.assign(Object.create(MetaState.prototype), { ...this, ...modifyObject });
    }

    withErrors(errors: VegkartError[]): MetaState {
        return this.override({ errors });
    }

    withLastHash(lastHash: string): MetaState {
        return this.override({ lastHash });
    }

    withNotifications(notifications: Notification[]): MetaState {
        return this.override({ notifications });
    }

    withLastVisitedNotifications(lastVisitedNotifications: Date): MetaState {
        return this.override({ lastVisitedNotifications });
    }
}

export class VegkartError extends Error {
    private __proto__: VegkartError;
    readonly uuid = uuidgen.v4();
    public readonly url: string;

    constructor(
        readonly message: string,
        readonly params?: { [key: string]: unknown },
        readonly severity: Severity = Severity.ERROR
    ) {
        super(message);
        this.url = window.window.location.toString();
        this.__proto__ = VegkartError.prototype;
    }
}

export type Notification = {
    time: Date;
    message: HTMLElement | string;
    callback?: () => void;
};

export enum Severity {
    ERROR = 'ERROR',
    WARN = 'WARN',
    INFO = 'INFO',
}

const getLastVisitedNotifications = () => {
    const value = localStorage.getItem(LAST_VISITED_NOTIFICATIONS_STORAGE_KEY);
    return new Date(value ?? 0);
};
const validateNotifications = (notifications: Notification[]) => {
    return notifications.filter(n => n.time instanceof Date && !isNaN(n.time));
};

// Simple way of adding notifications.
// If these notifications are frequently modified or need to be shipped to production fast,
// please consider creating an actual external service that supplies messages to Vegkart.
// Notifications are not considered permanent and may be removed from this list if no longer relevant.
const defaultNotifications: Notification[] = [
    // There are currently no notifications :)
];
